import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";
import { createStyles } from "@mui/styles";

const useUsersTableRowStyles = makeStyles((theme: Theme) =>
    createStyles({
        expandableRow: {
            "& .MuiTableCell-root": {
                background: theme.palette.background.grey,
                padding: `${theme.spacing(0, 2)} !important`,
                borderBottom: `1px solid ${theme.palette.neutrals.light}`,
            },
            "& .MuiTypography-root": {
                fontSize: 12,
                fontWeight: 600,
            },
        },
        disabledRow: {
            pointerEvents: "none",
            "& .MuiTableCell-root": {
                pointerEvents: "none",
                "& > *": {
                    opacity: 0.6,
                },
            },
        },
        removingStatus: {
            pointerEvents: "none",
            "& .MuiTableCell-root": {
                background: theme.palette.background.red,
                pointerEvents: "none",
                "& > *": {
                    opacity: 0.6,
                },
            },
        },
        savingStatus: {
            pointerEvents: "none",
            "& .MuiTableCell-root": {
                pointerEvents: "none",
                opacity: 0.6,
            },
        },
        toggleCloseBtn: {
            marginLeft: "auto",
            "& .MuiSvgIcon-root": {
                fontSize: 10,
                color: theme.palette.neutrals.dark,
            },
        },
    })
);

export default useUsersTableRowStyles;
